module.exports = __webpack_public_path__ + "2a43bb3689e8e48e022b9bb1dcea1fdf.png";